import { render } from "./index.vue?vue&type=template&id=f913d8be"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MultiImgPreview/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f913d8be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f913d8be', __exports__)) {
    api.reload('f913d8be', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f913d8be", () => {
    api.rerender('f913d8be', render)
  })

}


export default __exports__